import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AuthContext from '../../authentication/AuthContext';
import axios from 'axios';
import { useAlert } from 'react-alert';
import OrderHeader from './header/OrderHeader';
import ProductSearch from '../../common/search/ProductSearch';
import ProductSearchWithFiltersPane from '../../common/search/ProductSearchWithFiltersPane';
import QuickAdd from '../../common/search/QuickAdd';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import SmallOrderHeader from './header/SmallOrderHeader';
import OrderContext from './OrderContext';
import OrderTabs from './OrderTabs';
import CompletedOrder from './CompletedOrder';
import UserContext from '../../user/UserContext';

export default function OrderPage() {
    let params = useParams();
    let orderId = params.orderId;
    let cas = useContext(AuthContext);
    const { userDetails } = useContext(UserContext);
    let alert = useAlert();

    const filtersPaneControlGroupName = 'Filters Pane Control Group';

    let [orderHeader, setOrderHeader] = useState();
    let [basket, setBasket] = useState({
        items: [],
        delivered: [],
        rejected: [],
        substitutes: [],
        alternatives: [],
        contentLines: [],
        presell: [],
        capped: []
    });
    let [orderLinesLoading, setOrderLinesLoading] = useState(false);

    let [tabKey, setTabKey] = useState('accepted');
    let [searched, setSearched] = useState(false);
    let [loading, setLoading] = useState(false);
    let [searchResults, setSearchResults] = useState([]);
    let [searchResultCount, setSearchResultCount] = useState(0);

    let [shouldSetTab, setShouldSetTab] = useState(true);

    let [hideOnSubmit, setHideOnSubmit] = useState(false);

    let [showShrinkHeader, setShowShrinkHeader] = useState(false);

    const [singleMoq, setSingleMoq] = useState();

    useEffect(() => {
        setOrderLinesLoading(true);
        refreshOrderInfo();
        // eslint-disable-next-line
    }, [cas, orderId, userDetails]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    let handleScroll = () => {
        if (window.pageYOffset >= 500) {
            setShowShrinkHeader(true);
        } else {
            setShowShrinkHeader(false);
        }
    };

    let retrieveData = (url, responseCallback, errorMessage) => {
        axios
            .get(url, {
                headers: {
                    Authorization: cas,
                    'Content-Type': 'application/json'
                }
            })
            .then(responseCallback)
            .catch(() => {
                alert.error(errorMessage);
            });
    };

    let refreshOrderInfo = () => {
        retrieveData(
            window.CONFIG['ws.activoc-web-order-api.orders.status'].replace('{id}', orderId),
            statusResponse =>
                retrieveData(
                    statusResponse.data.orderStatus === 'DELIVERED' ||
                        statusResponse.data.orderStatus === 'INVOICED'
                        ? window.CONFIG['ws.activoc-web-order-api.delivered.summary'].replace('{id}', orderId)
                        : window.CONFIG['ws.activoc-web-order-api.orders.summary'].replace('{id}', orderId),
                    response => {
                        setOrderHeader(response.data);
                        retrieveData(
                            response.data.orderStatus === 'DELIVERED' ||
                                response.data.orderStatus === 'INVOICED'
                                ? window.CONFIG['ws.activoc-web-order-api.delivered.basket'].replace(
                                      '{id}',
                                      orderId
                                  )
                                : window.CONFIG['ws.activoc-web-order-api.orders.lines'].replace(
                                      '{id}',
                                      orderId
                                  ),
                            response2 => {
                                setBasket(response2.data);
                                setOrderLinesLoading(false);
                                if (shouldSetTab) {
                                    setTabKey(
                                        response2.data.rejected.length > 0 ||
                                            response2.data.alternatives.length > 0 ||
                                            response2.data.presell.length > 0 ||
                                            response2.data.substitutes.length > 0 ||
                                            response2.data.contentLines?.length > 0 ||
                                            response2.data.capped?.length > 0
                                            ? 'issues'
                                            : response2.data.items &&
                                              response2.data.items.length === 0 &&
                                              statusResponse.data.orderStatus !== 'DELETED'
                                            ? 'bestsellers'
                                            : tabKey
                                    );
                                    setShouldSetTab(false);
                                }
                            },
                            'ERROR: Unable to retrieve order line information.'
                        );
                        if (userDetails.currentFranchise) {
                            retrieveData(
                                window.CONFIG['ws.activoc-web-order-api.moq.progress'] +
                                    '?franchiseCode=' +
                                    userDetails.currentFranchise.code +
                                    '&orderId=' +
                                    orderId,
                                response3 =>
                                    setSingleMoq(
                                        response.data.supplierName === 'Nisa Ambient'
                                            ? response3.data.ambient
                                            : response3.data.chillfreeze
                                    ),
                                'ERROR: Unable to retrieve MOQ progress'
                            );
                        }
                    },
                    'ERROR: Unable to retrieve order information.'
                )
        );
    };

    return (
        <OrderContext.Provider
            value={{
                orderId: orderId,
                orderHeader: orderHeader,
                basket: basket,
                refreshOrderInfo: refreshOrderInfo,
                tabKey: tabKey,
                setTabKey: setTabKey,
                singleMoq: singleMoq
            }}
        >
            <div className={'page-header'}>
                {showShrinkHeader && (
                    <div className={'sticky'}>
                        <div className={'small-header'}>
                            <SmallOrderHeader />
                        </div>
                    </div>
                )}
                <div className={'content'}>
                    <div className={'page-header-container flex'}>
                        {orderHeader && (
                            <OrderHeader
                                setHideOnSubmit={hide => {
                                    setHideOnSubmit(hide);
                                    setTabKey(hide ? tabKey : 'accepted');
                                }}
                            />
                        )}
                    </div>
                    {orderHeader && orderHeader.orderStatus === 'OPEN' && (
                        <>
                            <div
                                className={
                                    'page-header-container search-header flex' +
                                    (showShrinkHeader ? ' sticky' : '')
                                }
                            >
                                <div className={'content flex'}>
                                    <div className={'product-search-header-wrapper'}>
                                        {!showShrinkHeader && <span>Missing something?</span>}
                                        {userDetails?.currentFranchise?.controlGroups.includes(
                                            filtersPaneControlGroupName
                                        ) ? (
                                            <ProductSearchWithFiltersPane
                                                showCount={false}
                                                setSearchResults={results => {
                                                    setSearchResults(results);
                                                    if (results.length > 0) {
                                                        setSearchResultCount(results.length);
                                                    } else {
                                                        setSearchResultCount(0);
                                                    }
                                                }}
                                                setLoading={isLoading => {
                                                    setLoading(isLoading);
                                                    if (isLoading) {
                                                        setTabKey('search');
                                                    }
                                                }}
                                                setSearched={setSearched}
                                                searched={searched}
                                                supplierCode={orderHeader.supplierCode}
                                                hideFilters={showShrinkHeader}
                                                data-testid={'product-search-with-filters-pane'}
                                                style={'orderDetailsStyle'}
                                            />
                                        ) : (
                                            <ProductSearch
                                                showCount={false}
                                                upIcon={faCaretUp}
                                                downIcon={faCaretDown}
                                                setSearchResults={results => {
                                                    setSearchResults(results);
                                                    if (results.length > 0) {
                                                        setSearchResultCount(results.length);
                                                    } else {
                                                        setSearchResultCount(0);
                                                    }
                                                }}
                                                setLoading={isLoading => {
                                                    setLoading(isLoading);
                                                    if (isLoading) {
                                                        setTabKey('search');
                                                    }
                                                }}
                                                setSearched={setSearched}
                                                searched={searched}
                                                supplierCode={orderHeader.supplierCode}
                                                hideFilters={showShrinkHeader}
                                                data-testid={'product-search'}
                                            />
                                        )}
                                    </div>
                                    <div
                                        className={`quickadd-header-wrapper ${userDetails?.currentFranchise?.controlGroups.includes(
                                            filtersPaneControlGroupName
                                        ) && 'with-filters-pane'}`}
                                    >
                                        {!showShrinkHeader && <span>Know the product code?</span>}
                                        <QuickAdd orderId={orderId} updateView={refreshOrderInfo} />
                                    </div>
                                </div>
                            </div>
                            {showShrinkHeader && <div className={'search-shrunk-placeholder content'} />}
                        </>
                    )}
                </div>
            </div>
            {!hideOnSubmit &&
                orderHeader &&
                (orderHeader.orderStatus === 'OPEN' ||
                    orderHeader.orderStatus === 'SUBMITTED' ||
                    orderHeader.orderStatus === 'DELETED') && (
                    <div className={'content order-lines'}>
                        <OrderTabs
                            loading={loading}
                            orderLinesLoading={orderLinesLoading}
                            searchResults={searchResults}
                            searchResultCount={searchResultCount}
                            searched={searched}
                        />
                    </div>
                )}
            {orderHeader &&
                (orderHeader.orderStatus === 'DELIVERED' || orderHeader.orderStatus === 'INVOICED') && (
                    <div className={'content order-lines'}>
                        <CompletedOrder orderLinesLoading={orderLinesLoading} />
                    </div>
                )}
        </OrderContext.Provider>
    );
}
